/** @jsx jsx */
import { jsx } from '@emotion/core';
import { Formik } from 'formik';
import { Input, PhoneNumber } from '../../../ui/Form/index';
import * as Yup from 'yup';
import React, { Component } from 'react';
import { get } from 'lodash';
import { DEFAULT_COUNTRY } from '../../../../utils/constants';
const phoneRegExp = /^(\\+)?([ .\-()0-9]){10,12}$/;
const FormValidationSchema = Yup.object().shape({
  // your_name: Yup.string().required('Required'),

  PhoneNumber: Yup.string()
    .required('this is a mandatory field')
    .matches(phoneRegExp, 'Phone number is not valid'),
});

import * as styles from './index.styles';
import Axios from 'axios';

export default class InputForm extends Component {
  state = {
    alert: { msgType: '', msg: '' },
  };

  onSubmit = async (values, { setSubmitting }) => {
    this.clearAlertMsg();
    const { fields } = this.props;
    const PhoneNumberParameterName = get(
      fields,
      'PhoneNumberParameterName.value',
      '',
    );
    const NameParameterName = get(fields, 'NameParameterName.value', '');
    const SubmissionAPIURL = get(fields, 'SubmissionAPIURL.value', '');
    const SuccessMessage = get(fields, 'SuccessMessage.value', '');
    const ErrorMessage = get(fields, 'ErrorMessage.value', '');
    let submitData = {};
    submitData[PhoneNumberParameterName] =
      this.countryData.DialingCode + values.PhoneNumber;
    //submitData[PhoneNumberParameterName] = values.PhoneNumber;
    submitData[NameParameterName] = values.your_name;
    submitData['solution'] = 'office space';

    const urlParams = new URLSearchParams(window.location.search);
    const solution = urlParams.get('solution');
    if (solution) {
      submitData['solution'] = solution;
    }

    try {
      const result = await Axios.post(SubmissionAPIURL, submitData);
      if (result.status == 200) {
        this.setState({
          alert: { msgType: 'success', msg: SuccessMessage },
        });
        this.clearAlertMsg();
        setSubmitting(false);
      } else {
        this.setState({
          alert: { msgType: 'error', msg: ErrorMessage },
        });
        this.clearAlertMsg();
        setSubmitting(false);
      }
    } catch (error) {
      this.setState({
        alert: { msgType: 'error', msg: ErrorMessage },
      });
      this.clearAlertMsg();
      setSubmitting(false);
    }
  };

  clearAlertMsg = () => {
    setTimeout(() => {
      this.setState({
        alert: { msgType: '', msg: '' },
      });
    }, 3000);
  };

  setCountryData = countryData => {
    this.countryData = countryData;
  };

  render() {
    const { fields } = this.props;

    const {
      alert: { msgType, msg },
    } = this.state;

    const PhoneNumberOptions = get(fields, 'PhoneNumberOptions', []);
    const defaultPhoneValue = get(
      fields,
      'DomainCountryISOCode2.value',
      DEFAULT_COUNTRY,
    );

    return (
      <Formik
        initialValues={{ your_name: '', PhoneNumber: '' }}
        validationSchema={FormValidationSchema}
        onSubmit={this.onSubmit}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleSubmit,
          isSubmitting,
          /* and other goodies */
        }) => (
          <form onSubmit={handleSubmit} className="contactform">
            <Input
              id="your_name"
              onChange={handleChange}
              error={errors.your_name && touched.your_name}
              errorMessage={errors.your_name}
              value={values.your_name}
              css={[styles.enquiryInput]}
              // {...styles.inputCssProps}
              placeholder={fields.YourNameWatermark.value}
            />

            <PhoneNumber
              options={PhoneNumberOptions}
              customCss={[styles.enquiryInput, styles.phoneNumberField]}
              // innerCss={styles.phoneNumberFieldCssProps}
              id="PhoneNumber"
              // ref={this.phoneNumberRef}
              defaultValue={defaultPhoneValue}
              placeholder={fields.PhoneNumberWatermark.value}
              error={errors.PhoneNumber && touched.PhoneNumber}
              errorMessage={errors.PhoneNumber}
              value={values.PhoneNumber}
              onInit={({ countryData }) => this.setCountryData(countryData)}
              onChange={handleChange}
              onChangeProp={(_event, countryData) =>
                this.setCountryData(countryData)
              }
            />

            <button
              type="submit"
              disabled={isSubmitting}
              css={[styles.enquirySubmit]}
            >
              {fields.CTAText.value}
            </button>
            {msgType && (
              <div css={[styles.msgBox, msgType && styles[msgType]]}>{msg}</div>
            )}
          </form>
        )}
      </Formik>
    );
  }
}
